import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { QualificationSection } from '../components/QualificationSection';
import { ProcessSection } from '../components/ProcessSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { FooterSection } from '../components/FooterSection';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-white font-body selection:bg-gold selection:text-navy-dark" data-id="element-234">
      <HeroSection data-id="element-235" />
      <ProblemSection data-id="element-236" />
      <SolutionSection data-id="element-237" />
      <QualificationSection data-id="element-238" />
      <ProcessSection data-id="element-239" />
      <FAQSection data-id="element-240" />
      <OfferSection data-id="element-241" />
      <FooterSection data-id="element-242" />
    </main>;
}